var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSparkling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7973 7.31482C14.0809 7.4503 14.0809 7.91993 13.7973 8.0554C12.2372 8.80063 10.9784 10.0595 10.2332 11.6201C10.0977 11.9038 9.62798 11.9038 9.49252 11.6201C8.74725 10.0595 7.48844 8.80063 5.92835 8.0554C5.64475 7.91993 5.64474 7.4503 5.92834 7.31482C7.48846 6.56954 8.7473 5.31068 9.49257 3.75055C9.62804 3.46696 10.0976 3.46696 10.2331 3.75055C10.9784 5.31068 12.2372 6.56954 13.7973 7.31482Z",
    fill: "#484848",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85791 4.59854C5.94538 4.64032 5.94538 4.78517 5.85791 4.82695C5.37673 5.05681 4.98847 5.44509 4.7586 5.92644C4.71682 6.01392 4.57195 6.01392 4.53017 5.92644C4.3003 5.44509 3.91204 5.05681 3.43086 4.82695C3.34339 4.78517 3.34339 4.64032 3.43086 4.59854C3.91205 4.36867 4.30032 3.9804 4.53018 3.4992C4.57196 3.41173 4.7168 3.41173 4.75859 3.4992C4.98845 3.9804 5.37672 4.36867 5.85791 4.59854Z",
    fill: "#484848",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68424 10.4842C5.80087 10.54 5.80087 10.7331 5.68424 10.7888C5.04267 11.0953 4.52499 11.613 4.2185 12.2548C4.1628 12.3714 3.96963 12.3714 3.91392 12.2548C3.60743 11.613 3.08976 11.0953 2.44818 10.7888C2.33155 10.7331 2.33155 10.54 2.44818 10.4842C3.08977 10.1778 3.60745 9.66006 3.91394 9.01847C3.96965 8.90184 4.16277 8.90184 4.21848 9.01847C4.52497 9.66006 5.04265 10.1778 5.68424 10.4842Z",
    fill: "#484848",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSparkling);
export default __webpack_public_path__ + "static/media/ic_sparkling.5fa813c4b7981661cb52e578af87ca42.svg";
export { ForwardRef as ReactComponent };